import { DirectoryGroupingConsts, ItemTypeConsts } from 'client/util/Constants';
import ConfigurationGroupApi from 'client/api/v2/ConfigurationGroupApi';
import MspState from 'client/components/models/MspState';
import OrganizationsApi from 'client/api/v2/OrganizationsApi';
import ProvidersApi from 'client/api/v2/ProvidersApi';
import createModel from 'client/store/modules/models/createModel';

const { groupTypes } = DirectoryGroupingConsts;

export const getDefaultItem = () => ({
  description: '',
  id: '',
  name: '',
  type: ItemTypeConsts.configurationGroup,
});

const model = createModel(getDefaultItem, 'id', ConfigurationGroupApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,

    bindConfigurationGroupToSystemGroups(context) {
      return context.dispatch('confirmAndBindAssociations', {
        parentType: groupTypes.policyGroup,
        targetType: groupTypes.systemGroup,
      });
    },

    bindConfigurationGroupToPolicies(context) {
      return context.dispatch('bindAssociations', {
        parentType: groupTypes.policyGroup,
        targetType: ItemTypeConsts.policy,
      });
    },

    bulkCreateDefaultPolicyGroups(context, policyGroups) {
      const createTasks = [];

      policyGroups.forEach(
        policyGroup => {
          createTasks.push(
            ConfigurationGroupApi.create({
              id: '',
              name: policyGroup.name,
              description: policyGroup.description,
            }),
          );
        },
      );

      return Promise.all(createTasks);
    },

    fetchPolicyGroupsBySearchTerm(context, searchTerm = '') {
      return ConfigurationGroupApi.fetchPolicyGroupsBySearchTerm(searchTerm)
        .then((response) => response.data);
    },

    fetchBoundPolicies(context, { id = '', limit = 10 }) {
      return ConfigurationGroupApi.fetchBoundPolicies(id, limit)
        .then((response) => response.data);
    },

    async createPolicyGroupTemplate(context, policyIds) {
      const { getters = {} } = context;
      if (context.rootGetters['SettingsModule/isProvider']) {
        const providerId = context.rootGetters['SettingsModule/getUser'].provider;
        const payload = { ...getters.item, policyIds };
        await ProvidersApi.createPolicyGroupTemplate(providerId, payload);
      }
    },

    async createPolicyGroupFromTemplate(context, item) {
      const { orgId } = MspState;
      const payload = (({ id }) => ({ templateId: id }))(item);
      const results = await OrganizationsApi.createPolicyGroupFromTemplate(payload, orgId);
      return results;
    },
  },

  getters: {
    ...model.getters,

    displayName: state => state.item.name,

    haveAssociationsChanged(state, getters) {
      return model.getters.haveAssociationsChanged(state, getters)(
        [ItemTypeConsts.policy, groupTypes.systemGroup],
      );
    },
  },

  mutations: {
    ...model.mutations,
  },
};
